import React from "react";
import { Flex } from "grid-styled";
import { chain } from "lodash";
import GlobalSeo from "../templates/meta";
import Overlay from "../components/overlay";
import ProjectGrid from "../components/projectgrid";

export default props => {
  const { allProject, globalSeo } = props.data;
  const projects = chain(allProject.edges)
    .map(({ node }) => node)
    .sortBy(p => {
      const date = p.metadata.find(m => m.itemType === "date");
      if (date) {
        return date.value;
      }
      return p.updatedAt;
    })
    .reverse()
    .value();
  return (
    <Flex w="100%">
      <GlobalSeo {...globalSeo} />
      <Overlay elements={[["RO"], ["Projecten"], ["&"], ["AD"]]} />
      <ProjectGrid projects={projects} />
    </Flex>
  );
};

export const pageQuery = graphql`
  query projectsQuery {
    allProject {
      edges {
        node {
          id
          slug
          title
          updatedAt
          metadata {
            itemType
            value
          }
          bannerImage {
            url
          }
        }
      }
    }
    globalSeo {
      en {
        siteName
        titleSuffix
        fallbackSeo {
          title
          description
          image {
            path
            width
            height
            format
            size
          }
        }
      }
      favicon {
        path
        width
        height
        format
        size
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/projecten.js